import { handleActions } from 'redux-actions'
import {
    setListarIngresosFinanciero,
    setListarPreguntasFinanciero,
    setListarProvinciasFinanciero,
    listarLimitesFinancieroIsLoading,
    listarLimitesFinancierohasError,
    setListarLimitesFinanciero,
    guardarCarritoFinancieroIsLoading,
    guardarCarritoFinancierohasError,
    setCarritoFinanciero,
    FinancieroisLoading,
    FinancierohasError,
    consultarCarritoFinancieroIsLoading,
    consultarCarritoFinancierohasError,
    setConsultarCarritoFinanciero,
    listarCotizadoresIsLoading,
    listarCotizadoreshasError,
    setListarCotizadores,
    enviarPDFFinancieroIsLoading,
    enviarPDFFinancierohasError,
    setEnviarPDFFinanciero,
    obtenerDataResponsabilidadIsLoading,
    obtenerDataResponsabilidadhasError,
    setObtenerDataResponsabilidad,
    guardarCarritoResponsabilidadIsLoading,
    guardarCarritoResponsabilidadhasError,
    setCarritoResponsabilidad,
    consultarCarritoResponsabilidadIsLoading,
    consultarCarritoResponsabilidadhasError,
    setConsultarCarritoResponsabilidad,
    listarProvinciasResponsabilidadIsLoading,
    listarProvinciasResponsabilidadhasError,
    setListarProvinciasResponsabilidad,
    girosNegocioFinancieroIsLoading,
    girosNegocioFinancierohasError,
    setGirosNegocioFinanciero
} from '../actions/aRamoLineaFinanciera';
  //Listar Limites - Cotizacion Financiero mediate redux-actions
  export const datosListarLimitesFinanciero = handleActions(
    {
      [listarLimitesFinancieroIsLoading]: (state) => ({...state,listarLimitesFinancieroIsLoading: true,listarLimitesFinancierohasError:false,}),
      [listarLimitesFinancierohasError]: (state) => ({...state,listarLimitesFinancierohasError:true,listarLimitesFinancieroIsLoading: false}),
      [setListarLimitesFinanciero]: (state,action) => ({...state,listarLimites: action.payload, listarLimitesFinancierohasError:false,listarLimitesFinancieroIsLoading: false })
    },
    {
      listarLimitesFinancieroIsLoading: false,
      listarLimitesFinancierohasError: false,
      listarLimites: [],
    }
  );

    //Listar Cotizadores - Cotizacion Financiero mediate redux-actions
    export const datosListarCotizadores = handleActions(
      {
        [listarCotizadoresIsLoading]: (state) => ({...state,listarCotizadoresIsLoading: true,listarCotizadoreshasError:false,}),
        [listarCotizadoreshasError]: (state) => ({...state,listarCotizadoreshasError:true,listarCotizadoresIsLoading: false}),
        [setListarCotizadores]: (state,action) => ({...state,listarCotizadores: action.payload, listarCotizadoreshasError:false,listarCotizadoresIsLoading: false })
      },
      {
        listarCotizadoresIsLoading: false,
        listarCotizadoreshasError: false,
        listarCotizadores: [],
      }
    );

 //Guardar Carrito - Cotizacion Financiero mediate redux-actions
 export const datosCotizacionFinanciero = handleActions(
  {
    [guardarCarritoFinancieroIsLoading]: (state) => ({...state,guardarCarritoFinancieroIsLoading: true,guardarCarritoFinancierohasError:false,}),
    [guardarCarritoFinancierohasError]: (state) => ({...state,guardarCarritoFinancierohasError:true,guardarCarritoFinancieroIsLoading: false}),
    [setCarritoFinanciero]: (state,action) => ({...state,respuestaGuardarFinanciero: action.payload, guardarCarritoFinancierohasError:false,guardarCarritoFinancieroIsLoading: false })
  },
  {
    guardarCarritoFinancieroIsLoading: false,
    guardarCarritoFinancierohasError: false,
    respuestaGuardarFinanciero: {},
  }
);

 //datos(Ingresos,Preguntas) - Cotizacion Financiero mediate redux-actions

 export const dataFinanciero = handleActions(
  {
    [FinancieroisLoading]: (state) => ({ ...state, FinancieroisLoading: true, FinancierohasError: '' }),
    [FinancierohasError]: (state, action) => ({ ...state, FinancierohasError: action.payload, FinancieroisLoading: false}),
    [setListarPreguntasFinanciero]: (state,action) => ({...state,listarPreguntas: action.payload, FinancierohasError:false,FinancieroisLoading: false }),
    [setListarIngresosFinanciero]: (state,action) => ({...state,listarIngresos: action.payload, FinancierohasError:false,FinancieroisLoading: false }),
    [setListarProvinciasFinanciero]: (state,action) => ({...state,listarProvincias: action.payload, FinancierohasError:false,FinancieroisLoading: false }),
  },
  {
    FinancieroisLoading: false,
    FinancierohasError: '',
    listarPreguntas: [],
    listarIngresos: [],
    listarProvincias: [],
  }
);


//Consulta Carrito - Cotizacion Financiero mediate redux-actions

  export const datosCarritoFinanciero = handleActions(
    {
      [consultarCarritoFinancieroIsLoading]: (state) => ({ ...state, consultarCarritoFinancieroIsLoading: true, consultarCarritoFinancierohasError: false}),
      [consultarCarritoFinancierohasError]: (state) => ({ ...state, consultarCarritoFinancierohasError: true, consultarCarritoFinancieroIsLoading: false}),
      [setConsultarCarritoFinanciero]: (state,action) => ({...state,datosCarritoFinanciero: action.payload, consultarCarritoFinancierohasError:false,consultarCarritoFinancieroIsLoading: false }),
    },
    {
      consultarCarritoFinancieroIsLoading: false,
      consultarCarritoFinancierohasError: false,
      datosCarritoFinanciero: [],
    }
  );

  //Enviar PDF - Cotizacion Financiero mediate redux-actions
  export const datosEnviarPDFFinanciero = handleActions(
    {
      [enviarPDFFinancieroIsLoading]: (state) => ({...state,enviarPDFFinancieroIsLoading: true,enviarPDFFinancierohasError:false,}),
      [enviarPDFFinancierohasError]: (state) => ({...state,enviarPDFFinancierohasError:true,enviarPDFFinancieroIsLoading: false}),
      [setEnviarPDFFinanciero]: (state,action) => ({...state,respuestaCorreo: action.payload, enviarPDFFinancierohasError:false,enviarPDFFinancieroIsLoading: false })
    },
    {
      enviarPDFFinancieroIsLoading: false,
      enviarPDFFinancierohasError: false,
      respuestaCorreo: [],
    }
  );


  //datos(Selects Primera Pantalla) - Cotizacion Responsabilidad mediate redux-actions

  export const dataResponsabilidad = handleActions(
    {
      [obtenerDataResponsabilidadIsLoading]: (state) => ({ ...state, obtenerDataResponsabilidadIsLoading: true, obtenerDataResponsabilidadhasError: '' }),
      [obtenerDataResponsabilidadhasError]: (state, action) => ({ ...state, obtenerDataResponsabilidadhasError: action.payload, obtenerDataResponsabilidadIsLoading: false}),
      [setObtenerDataResponsabilidad]: (state,action) => ({...state,datosResponsabilidad: action.payload, obtenerDataResponsabilidadhasError:false,obtenerDataResponsabilidadIsLoading: false }),
    },
    {
      obtenerDataResponsabilidadIsLoading: false,
      obtenerDataResponsabilidadhasError: '',
      datosResponsabilidad: {},
    }
  );


  //Listar Provincias - Cotizacion Responsabilidad mediate redux-actions
  export const datosProvinciasResponsabilidad = handleActions(
    {
      [listarProvinciasResponsabilidadIsLoading]: (state) => ({ ...state, listarProvinciasResponsabilidadIsLoading: true, listarProvinciasResponsabilidadhasError: false}),
      [listarProvinciasResponsabilidadhasError]: (state) => ({ ...state, listarProvinciasResponsabilidadhasError: true, listarProvinciasResponsabilidadIsLoading: false}),
      [setListarProvinciasResponsabilidad]: (state,action) => ({...state, listaProvinciasResponsabilidad: action.payload, listarProvinciasResponsabilidadhasError:false,listarProvinciasResponsabilidadIsLoading: false }),
    },
    {
      listarProvinciasResponsabilidadIsLoading: false,
      listarProvinciasResponsabilidadhasError: false,
      listaProvinciasResponsabilidad: [],
    }
  );


   //Guardar Carrito - Cotizacion Responsabilidad mediate redux-actions
 export const datosCotizacionResponsabilidad = handleActions(
  {
    [guardarCarritoResponsabilidadIsLoading]: (state) => ({...state,guardarCarritoResponsabilidadIsLoading: true, guardarCarritoResponsabilidadhasError: false,}),
    [guardarCarritoResponsabilidadhasError]: (state) => ({...state,guardarCarritoResponsabilidadhasError:true, guardarCarritoResponsabilidadIsLoading: false}),
    [setCarritoResponsabilidad]: (state,action) => ({...state,respuestaGuardarResponsabilidad: action.payload, guardarCarritoResponsabilidadhasError:false,guardarCarritoResponsabilidadIsLoading: false })
  },
  {
    guardarCarritoResponsabilidadIsLoading: false,
    guardarCarritoResponsabilidadhasError: false,
    respuestaGuardarResponsabilidad: {},
  }
);


//Consulta Carrito - Cotizacion Responsabilidad mediate redux-actions

export const datosCarritoResponsabilidad = handleActions(
  {
    [consultarCarritoResponsabilidadIsLoading]: (state) => ({ ...state, consultarCarritoResponsabilidadIsLoading: true, consultarCarritoResponsabilidadhasError: false}),
    [consultarCarritoResponsabilidadhasError]: (state) => ({ ...state, consultarCarritoResponsabilidadhasError: true, consultarCarritoResponsabilidadIsLoading: false}),
    [setConsultarCarritoResponsabilidad]: (state,action) => ({...state,datosCarritoResponsabilidad: action.payload, consultarCarritoResponsabilidadhasError:false,consultarCarritoResponsabilidadIsLoading: false }),
  },
  {
    consultarCarritoResponsabilidadIsLoading: false,
    consultarCarritoResponsabilidadhasError: false,
    datosCarritoResponsabilidad: [],
  }
);

  //Giro de Negocios  - Cotizacion Lineas Financieras

export const girosNegocioFinanciero = handleActions(
  {
    [girosNegocioFinancieroIsLoading]: (state) => ({ ...state, girosNegocioFinancieroIsLoading: true, girosNegocioFinancierohasError: false}),
    [girosNegocioFinancierohasError]: (state) => ({ ...state, girosNegocioFinancierohasError: true, girosNegocioFinancieroIsLoading: false}),
    [setGirosNegocioFinanciero]: (state,action) => ({...state,datosGirosNegocio: action.payload, girosNegocioFinancierohasError:false,girosNegocioFinancieroIsLoading: false }),
  },
  {
    girosNegocioFinancieroIsLoading: false,
    girosNegocioFinancierohasError: false,
    datosGirosNegocio: [],
  }
);
